import { connect } from 'react-redux';
import Simulation from '../components/Simulation/Simulation';
import {
  setDesignGrouping,
  setSimulationSlot,
  setSimulationSort,
  setSimulationView,
  setDesignFilter,
  loadContenders,
  setTopCount,
  startSimulation,
  resetSimulation,
} from '../actions/simulation';
import { setMainPage } from '../actions/app';

const mapStateToProps = (state) => {
  return {
    studentInfo: {
      ...state.auth,
    },
    ...state.simulation,
    appCode: state.app.code, 
    isGameMode: state.app.gameMode,
    hasDistrict: state.app.hasDistrict,
    competition: state.app.competition,
  };
};

const mapDispatchToProps = {
  setDesignGrouping,
  setSimulationSlot,
  setSimulationSort,
  setSimulationView,
  setDesignFilter,
  loadContenders,
  setTopCount,
  startSimulation,
  resetSimulation,
  setMainPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Simulation);
